import { stringFromJSONValue } from './parser'

export class UnitLegendModel {
  public key: string
  public desc: string

  public constructor(key: string, desc: string) {
    this.key = key
    this.desc = desc
  }

  public static modelFromJSON(json: any): UnitLegendModel {
    return new UnitLegendModel(
      stringFromJSONValue(json['UnitKey']),
      stringFromJSONValue(json['Description'])
    )
  }
}
